var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('form',{staticClass:"extra-panel"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('template.donation_part_of_the_giving_day', { shortlink: _vm.shortlink, title: _vm.title }))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }